import ApiClient from '@afosto/api/ApiClient';

class Items {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Update a shipment&#39;s backorder items
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update the shipment&#39;s items that are backorder
   * @returns {Promise}
   */
  updateShipmentBackorders(id, body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments/${id}/items/backorders`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Set missing
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update items that are missing
   * @returns {Promise}
   */
  updateShipmentItemMissing(id, body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments/${id}/items/missing`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Update a shipment&#39;s overage
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update items that were not expected
   * @returns {Promise}
   */
  updateShipmentOverage(id, body, options = {}) {
    return this.apiClient.request({
      url: `/lcs/shipments/${id}/items/overage`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const items = new Items();

export default Items;
